var map = {
	"./product-shirt1.jpg": 41,
	"./product-shirt1.png": 3903,
	"./product-shirt2.jpg": 9998,
	"./product-shirt2.png": 3646,
	"./product-shirt3.jpg": 2385,
	"./product-shirt3.png": 7771,
	"./shirt1.jpg": 6041,
	"./shirt2.jpg": 9652,
	"./shirt3.jpg": 3229
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;